import { combineEpics, ofType } from 'redux-observable'
import { from } from 'rxjs'
import { map, pluck, switchMap } from 'rxjs/operators'

import * as EmbedsAPI from 'api/embeds'

import * as EmbedActions from './actions'

const updateEmbed = (action$) =>
  action$.pipe(
    ofType(EmbedActions.updateChildEmbed.toString()),
    pluck('payload'),
    map(({ embedId, properties = {} }) => {
      const mappedProperties = properties.map((property) => ({
        operation: 'set',
        property: property.setting,
        value: property.value,
      }))

      return { embedId, mappedProperties }
    }),
    switchMap((updateData) =>
      from(
        EmbedsAPI.patchSpecficEmbed(
          updateData.embedId,
          updateData.mappedProperties
        )
      )
    ),
    map(({ data }) => EmbedActions.receiveUpdatedChildEmbed(data))
  )

export default combineEpics(updateEmbed)
